//日付、時間をJSTに変換する関数

import { format, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";

interface DateConverterOptions {
  timezone?: string;
  formatString?: string;
}

export const DateConverter = (
  data: string,
  dateConverterOptions: DateConverterOptions = {}
) => {
  //デフォルト値設定
  const { timezone = "Asia/Tokyo", formatString = "yyyy-MM-dd HH:mm:ss" } =
    dateConverterOptions;

  const date = parseISO(data);
  const ConvertedDate = toZonedTime(date, timezone);
  const formattedTime = format(ConvertedDate, formatString);

  return formattedTime;
};
